<template>
  <div>
    <div class="card-header text-right" v-if="!readonly">
      <button
        class="btn btn btn-primary"
        type="button"
        v-on:click="openAddOccupantModal"
      >
        Add Occupant
      </button>
    </div>
    <div class="card-body">
      <div class="alert alert-info" v-if="!hasOccupants">
        <p class="mb-0">
          You haven't added any occupants. Please click the "Add Occupant"
          button to add one.
        </p>
      </div>
      <table
        class="table carpenter table-bordered table-hover"
        v-if="hasOccupants"
      >
        <thead>
          <tr>
            <th>Name</th>
            <th>Type</th>
            <th>Date of Birth</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-bind:key="index"
            v-for="(occupant, index) in occupants"
            v-on:click="openEditOccupantModal(occupant)"
          >
            <td>{{ occupant.first_name }} {{ occupant.last_name }}</td>
            <td>
              {{ occupant.type ? occupant.type.label : 'Not Provided' }}
            </td>
            <td v-text="parseDateOfBirth(occupant)"></td>
          </tr>
        </tbody>
      </table>

      <v-add-third-party-occupant
        :incident="incident"
        :third-party="thirdParty"
        v-if="modals.add"
        v-on:close="closeAddOccupantModal"
        :types="types"
        :client="client"
        :positions="positions"
        v-on:added="occupantWasAdded"
      ></v-add-third-party-occupant>

      <v-edit-third-party-occupant
        :incident="incident"
        v-if="modals.edit"
        v-on:close="closeEditOccupantModal"
        :types="types"
        :occupant="editingOccupant"
        :third-party="thirdParty"
        :positions="positions"
        :readonly="readonly"
        v-on:deleted="removeOccupant"
        v-on:updated="occupantWasUpdated"
      ></v-edit-third-party-occupant>
    </div>
    <div class="card-footer" v-if="!readonly">
      <button
        type="button"
        class="btn btn-danger"
        @click="emitRemoveThirdParty"
      >
        Remove Third Party
      </button>
    </div>
  </div>
</template>
<script>
import AddThirdPartyOccupant from './Children/AddThirdPartyOccupant.vue';
import EditThirdPartyOccupant from './Children/EditThirdPartyOccupant.vue';

export default {
  props: {
    incident: {
      type: String,
      required: true
    },
    thirdParty: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },

  components: {
    'v-add-third-party-occupant': AddThirdPartyOccupant,
    'v-edit-third-party-occupant': EditThirdPartyOccupant
  },

  data() {
    return {
      modals: {
        add: false,
        edit: false
      },
      types: [],
      positions: [],
      editingOccupant: null,
      indicator: false
    };
  },

  computed: {
    occupants() {
      return this.thirdParty?.third_party_occupants;
    },

    hasOccupants() {
      return !!(this.occupants && this.occupants.length);
    },

    client() {
      return this.$store.getters['Incident/client'];
    }
  },
  mounted() {
    this.mount();
  },

  methods: {
    mount() {
      window.Ajax.get('/occupant-types')
        .then(response => {
          this.types = response.data;
        })
        .catch(error => {});

      window.Ajax.get('/seat-positions')
        .then(response => {
          this.positions = response.data;
        })
        .catch(error => {});
    },

    parseDateOfBirth(occupant) {
      if (occupant.date_of_birth) {
        return window.DateManager.format(occupant.date_of_birth);
      }

      return 'Not Provided';
    },

    findIndex(identifier) {
      return this.occupants.findIndex(item => {
        return item.identifier === identifier;
      });
    },

    removeOccupant(occupant) {
      this.closeEditOccupantModal();

      this.$store.commit('Incident/removeThirdPartyOccupant', {
        thirdParty: this.thirdParty,
        occupant
      });

      window.toastify.success(
        'Occupant Deleted',
        'The occupant was deleted successfully!'
      );
    },

    occupantWasUpdated(occupant) {
      this.closeEditOccupantModal();

      this.$store.commit('Incident/updateThirdPartyOccupant', {
        thirdParty: this.thirdParty,
        occupant
      });

      window.toastify.success(
        'Success!',
        'The occupant was updated successfully!'
      );
    },

    closeEditOccupantModal() {
      this.modals.edit = false;
      this.editingOccupant = null;
    },

    openEditOccupantModal(occupant) {
      this.editingOccupant = occupant;
      this.modals.edit = true;
    },

    occupantWasAdded(occupant) {
      this.$store.commit('Incident/addThirdPartyOccupant', {
        thirdParty: this.thirdParty,
        occupant
      });

      this.closeAddOccupantModal();

      this.$emit('updated', true);

      window.toastify.success(
        'Success!',
        'The occupant was added successfully!'
      );
    },

    openAddOccupantModal() {
      this.modals.add = true;
    },

    closeAddOccupantModal() {
      this.modals.add = false;
    },

    emitRemoveThirdParty() {
      this.$emit('remove-third-party');
    }
  },

  watch: {
    $route(to, from) {
      this.mount();
    }
  }
};
</script>
